import React from 'react';
import {
  PdfIcon,
  CsvIcon,
  DocIcon,
  DocxIcon,
  TxtIcon,
  PptIcon,
  PptxIcon,
  XlsIcon,
  XlsxIcon,
  AiIcon,
  JpegIcon,
  PngIcon,
  GifIcon,
  BmpIcon,
  CadIcon
} from '../svgIcon/FileIcon';

type TProps = {
  format: string;
  name: string;
  width?: number;
  height?: number;
};

// フォーマットに合わせてアイコンを返す
export const SelectIcon: React.FC<TProps> = (props: TProps) => {
  const { format, name, width, height } = props;
  return (
    <>
      {format == 'application/pdf' && <PdfIcon width={width} height={height} />}
      {format == 'application/msword' && (
        <DocIcon width={width} height={height} />
      )}
      {format ==
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && (
        <DocxIcon width={width} height={height} />
      )}
      {format == 'application/vnd.ms-excel' && (
        <XlsIcon width={width} height={height} />
      )}
      {format ==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && (
        <XlsxIcon width={width} height={height} />
      )}
      {format == 'application/vnd.ms-powerpoint' && (
        <PptIcon width={width} height={height} />
      )}
      {format ==
        'application/vnd.openxmlformats-officedocument.presentationml.presentation' && (
        <PptxIcon width={width} height={height} />
      )}
      {format == 'text/plain' && <TxtIcon width={width} height={height} />}
      {format == 'text/csv' && <CsvIcon width={width} height={height} />}
      {format == 'application/postscript' && (
        <AiIcon width={width} height={height} />
      )}
      {format == 'image/jpeg' && <JpegIcon width={width} height={height} />}
      {format == 'image/gif' && <GifIcon width={width} height={height} />}
      {format == 'image/png' && <PngIcon width={width} height={height} />}
      {format == 'image/bmp' && <BmpIcon width={width} height={height} />}
      {(name.endsWith('.dwg') ||
        name.endsWith('.vwx') ||
        name.endsWith('.jwc') ||
        name.endsWith('.dxf')) && <CadIcon width={width} height={height} />}
    </>
  );
};
